import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/it'; // moment default cuma 'en' — import biar ada data bulan/hari Italia
import enTranslations from './config/locales/en.json';
import itTranslations from './config/locales/it.json';

const SUPPORTED_LANGS = ['en', 'it'];

// Bahasa awal: prioritas dari URL `?lang=` (dikirim app/web-marketer biar konsisten
// dengan bahasa app), lalu yang tersimpan di localStorage, terakhir default 'en'.
// Yang dari URL di-persist ke `skai1Language` supaya header x-lang (konten BE dari API)
// dan language switcher (PurchaseLayout) ikut konsisten sejak load pertama.
const getInitialLanguage = () => {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && SUPPORTED_LANGS.includes(urlLang.toLowerCase())) {
      const lang = urlLang.toLowerCase();
      localStorage.setItem('skai1Language', lang);
      return lang;
    }
    const saved = localStorage.getItem('skai1Language');
    if (saved && SUPPORTED_LANGS.includes(saved)) return saved;
  } catch (e) {
    // window/localStorage tidak tersedia → fallback ke default
  }
  return 'en';
};

const initialLanguage = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    it: { translation: itTranslations },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

// Sinkronin locale moment dgn bahasa app → nama bulan di tanggal ikut lokalisasi (mis. "lug"
// bukan "Jul"). Cover load awal + tiap ganti bahasa. Cuma 'it' yg di-import; lainnya fallback 'en'.
const syncMomentLocale = (lng) => { moment.locale(lng === 'it' ? 'it' : 'en'); };
syncMomentLocale(initialLanguage);
i18n.on('languageChanged', syncMomentLocale);

export default i18n;